import { inject, Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor{

  private token : string = '';
  private tokenExtern : string = '';
  constructor(
    private storageService : StorageService
  ) {
    this.storageService.getToken()
    .subscribe((token : any) => {
      if(token != null && token != undefined) {
        this.token = token;
      }
    },(error: any) : any => {
      console.log(error);
    });

    this.storageService.getTokenExtern()
    .subscribe((tokenExtern : any) => {
      if(tokenExtern != null && tokenExtern != undefined && tokenExtern != '') {
        this.tokenExtern = tokenExtern;
      }
    },(error: any) : any => {
      console.log(error);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lastSegment = req.url.split('/').pop();

    // Si está iniciando sesión sin token externo, limpiamos tokenExtern pero dejamos pasar la request sin tocar body/headers
    if (lastSegment === 'authenticate') {
      this.tokenExtern = '';
      return next.handle(req);
    }

    // Login con factor alterno (authenticate-fa): dejamos pasar igual, puede usar body tal cual
    if (lastSegment === 'authenticate-fa') {
      return next.handle(req);
    }

    if(req.url.includes(".json") || req.url.includes("admin/files") || req.url.includes('alpha_3') ){
      return next.handle(req)
    }

    let headers: any = {'Content-Type': `application/json` }

    if(this.token && this.tokenExtern == '') {
      headers.Authorization = `Bearer ${this.token}`
    }
  
    let request:any

    if(req.method.toLowerCase() === "post"){
      if(req.body instanceof FormData){
        request = req.clone({
          body: req.body.append("id_client", environment.CLIENT)
        })
      }else{
        this.tokenExtern != null && this.tokenExtern != undefined && this.tokenExtern != '' ? 
        request = req.clone({
          setHeaders:headers,
          params: req.params.set("id_client", environment.CLIENT)
          .set('token',this.tokenExtern)
        })
        : request = req.clone({
          setHeaders:headers,
          params: req.params.set("id_client", environment.CLIENT)
        })
      }
    }
    else if(req.method.toLowerCase() === "get" || req.method.toLowerCase() === "put" || req.method.toLowerCase() === "delete"){
    

      this.tokenExtern != null && this.tokenExtern != undefined && this.tokenExtern != '' ? 
      request = req.clone({
        setHeaders:headers,
        params: req.params.set("id_client", environment.CLIENT)
        .set('token',this.tokenExtern)
      })
      :  request = req.clone({
        setHeaders:headers,
        params: req.params.set("id_client", environment.CLIENT)
      })
    }
    return next.handle(request)
  }

}

export const tokenInterceptorFn: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const token: string = storageService.getToken().getValue() || '';
  const tokenExtern: string = storageService.getTokenExtern().getValue() || '';

  const lastSegment = req.url.split('/').pop();

  if (lastSegment === 'authenticate' || lastSegment === 'authenticate-fa') {
    return next(req);
  }

  if (req.url.includes('.json') || req.url.includes('admin/files') || req.url.includes('alpha_3')) {
    return next(req);
  }

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  if (token && !tokenExtern) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  let request: HttpRequest<any>;

  if (req.method.toLowerCase() === 'post') {
    if (req.body instanceof FormData) {
      req.body.append('id_client', environment.CLIENT);
      request = req.clone({ body: req.body });
    } else if (tokenExtern) {
      request = req.clone({
        setHeaders: headers,
        params: req.params.set('id_client', environment.CLIENT).set('token', tokenExtern),
      });
    } else {
      request = req.clone({
        setHeaders: headers,
        params: req.params.set('id_client', environment.CLIENT),
      });
    }
  } else {
    if (tokenExtern) {
      request = req.clone({
        setHeaders: headers,
        params: req.params.set('id_client', environment.CLIENT).set('token', tokenExtern),
      });
    } else {
      request = req.clone({
        setHeaders: headers,
        params: req.params.set('id_client', environment.CLIENT),
      });
    }
  }

  return next(request);
};
